'use client';

import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { TTournamentBadge } from '@/api/cms';
import { ImageComponent } from '@/components/Image';
import { badgeGradientMap } from '../../helpers';
import { getBadgeConfig } from './helpers';

import { ScTournamentBadge } from './styled';

interface ITournamentBadge {
  type: TTournamentBadge;
}

export const TournamentBadge: FC<ITournamentBadge> = ({ type }) => {
  const { t } = useTranslation('tournaments');
  const { decorCoins, decorStars, label, icon, iconStart } = getBadgeConfig(
    type,
    t
  );
  const badgeGradient = badgeGradientMap[type];

  return (
    <ScTournamentBadge className={badgeGradient}>
      {decorCoins && (
        <>
          <ImageComponent
            alt="coin"
            className="decor coin-right"
            height={14}
            src="/tournaments/tournament-card/right-coin-badge.webp"
            width={14}
          />
          <ImageComponent
            alt="coin"
            className="decor coin-left"
            height={14}
            src="/tournaments/tournament-card/left-coin-badge.webp"
            width={14}
          />
        </>
      )}
      {decorStars && (
        <>
          <ImageComponent
            alt="star"
            className="decor star-right"
            height={14}
            src="/tournaments/tournament-card/right-star-badge.webp"
            width={14}
          />
          <ImageComponent
            alt="star"
            className="decor star-left"
            height={14}
            src="/tournaments/tournament-card/left-star-badge.webp"
            width={14}
          />
        </>
      )}
      {iconStart && (
        <ImageComponent
          alt="icon"
          className="icon start"
          height={iconStart.height}
          src={iconStart.src}
          width={iconStart.width}
        />
      )}
      <span className="label">{label}</span>
      {icon && (
        <ImageComponent
          alt="icon"
          className="icon"
          height={icon.height}
          src={icon.src}
          width={icon.width}
        />
      )}
    </ScTournamentBadge>
  );
};
